import { GET_CUSTOMER_REFERRALS_API } from '../constants/AppConstants';

/**
 * Service to get the list of all the customer referrals.
 * @returns {Object} - Response received from the API along with the ok status
 */
const getCustomerReferral = async () => {
  try {
    const response = await fetch(GET_CUSTOMER_REFERRALS_API, {
      method: 'GET',
    });
    let json = [];
    if (response.status !== 204) {
      json = await response.json();
    }
    return { ok: response.ok, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: error.message } };
  }
};

export default getCustomerReferral;
